<template>
  <div
    class="ota-p14 inline-block rounded text-sm text-white px-5 py-3"
    :class="classes"
    @click="onClick"
  >
    <span v-text="text" />
  </div>
</template>

<script>
import { getEuros } from '@/utils/general'

export default {
  name: 'ProductCreditBadge',
  props: {
    credits: {
      type: Number,
      default: 0
    },
    isOutOfStock: {
      type: Boolean,
      default: false
    },
    isAuthenticated: {
      type: Boolean,
      default: false
    },
    isVisible: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    country: {
      type: String,
      default: 'nl'
    }
  },
  computed: {
    classes () {
      return {
        'bg-purple-400': this.isLoading || (!this.isOutOfStock && this.isVisible),
        'bg-red-300': this.isOutOfStock && this.isVisible && !this.isLoading,
        'bg-orange-300': !this.isVisible && !this.isLoading,
        'cursor-pointer': !this.isAuthenticated
      }
    },
    text () {
      if (!this.isAuthenticated) {
        return this.$t('Loyalty.Webshop.ProductDetail.LoginSeeCredits')
      }

      if (!this.isVisible && !this.isLoading) {
        return this.$t('Loyalty.Webshop.ProductDetail.ComingSoon')
      }

      if (this.isOutOfStock && !this.isLoading) {
        return this.$t('Loyalty.Webshop.ProductDetail.ProductSoldOut')
      }

      return this.$t('Loyalty.Webshop.Navbar.YourCredits', { price: getEuros(this.country, this.credits) })
    }
  },
  methods: {
    onClick () {
      if (!this.isAuthenticated) {
        this.$emit('unauthenticatedProductClick')
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
.ota-p14 {
  @apply text-sm !important;
}
</style>
